export const EMAIL_VALIDATION = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/;

export const IIBB_NUMBER_REGEX = /^[0-9-]+$/;

//? Regular expression that matches hyphens (-), dots (.), and slashes (/).
//? It is used to replace these characters in a date with a hyphen (-) to maintain
//? a standard date format.
export const REGEX_DATE_FORMAT = /[-/.]/g;
